import { CraneSlice } from "../store/slices/craneSlice";

export const calculateMHRadius = (state: CraneSlice) => {
  // const radians = ((state.craneParameters.boomAngle + 7) * Math.PI) / 180;
  const radians = ((90 - state.craneParameters.boomAngle + 7) * Math.PI) / 180;
  const amp = Math.sin(radians);
  const radius = amp * 330;
  return radius;
};

const calculateSwlBasedOnRadius = (radius: number) => {
  radius = Math.pow(radius - 300, 2);
  radius = radius / 10;
  radius = Math.min(radius, 2000);
  radius = radius + 1150;
  return radius;
};

export const calculateSWL = (state: CraneSlice) => {
  let radius = calculateMHRadius(state);
  radius = calculateSwlBasedOnRadius(radius);
  return radius;
};
